import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";

import {
    GET_RP_DETAIL_GAS_DELIVERY_FUEL,
    baseUrl,
} from "../../../helpers/url_api_constant";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import PropTypes from "prop-types";
import Select from "react-select";
import logoPttColor from "../../../assets/images/PTT_LogoColor.png";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";

function TabBillingSummary(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    let history = useHistory();
    let { pid, date } = useParams();

    const dispatch = useDispatch();
    const permission = getPermission();
    const [pageAdd, setPageAdd] = useState(false);
    const [modelDeviceList, setModelDeviceList] = useState([]);
    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);

    //onInit//
    useEffect(function () {
        fetchData();
    }, [props.deliveryGasYear]);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const gotoMainMenu = () => {
        history.push({
            pathname: "/delivery-gas-fuel-gas-report", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_RP_DETAIL_GAS_DELIVERY_FUEL, { MONTHFLOW_YEAR: moment(props.deliveryGasYear).format("YYYY-01-01"), IS_BILLING: true });
            // console.log(res);
            let tempData = [{ ZONE_NAME: "East", COLOR: "#7A83B8", DATA: [] }, { ZONE_NAME: "West", COLOR: "#6070BF", DATA: [] }, { ZONE_NAME: "Overall", COLOR: "#576FF7", DATA: [] }]

            let groupData = res.data.rpGasDeliveryList.reduce((group, item) => {
                const { ZoneName } = item;
                group[ZoneName] = group[ZoneName] ?? [];
                group[ZoneName].push(item);
                return group;
            }, {});

            for (const [zone, zoneValue] of Object.entries(groupData)) {
                // console.log(zone, zoneValue);
                let groupDataZone = zoneValue.reduce((group, item) => {
                    const { TotalFlow } = item;
                    group[TotalFlow] = group[TotalFlow] ?? [];
                    group[TotalFlow].push(item);
                    return group;
                }, {});

                for (const [meterName, meterValue] of Object.entries(groupDataZone)) {
                    // console.log(`${meterName}: ${meterValue}`);
                    let index = tempData.findIndex(row => row.ZONE_NAME == zone)

                    tempData[index].DATA.push({ TOTAL_FLOW: meterName, DATA_FLOW: meterValue })
                }
            }
            setModelDeviceList(tempData)

        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    return (
        <React.Fragment>
            <Row>
                <Col
                    sm="12"
                    className="d-flex align-items-center justify-content-end"
                >
                    <div className="d-grid gap-2 d-md-block">
                        <Button
                            onClick={() => gotoMainMenu()}
                            // className="btn-rounded"
                            color="secondary"
                            className="mt-0 mb-0"
                        >
                            <i className="fas fa-angle-double-left"></i>
                            &nbsp; Back
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col sm="12">
                    <div style={{ width: "100%" }}>
                        {/* className="table-responsive" */}
                        {/* hover-table-highlight */}
                        <Table className="table table-bordered table-striped mb-0">
                            <thead style={{ fontSize: "1.5vh" }}>
                                <tr>
                                    <th colSpan={3} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "1.5vw" }}>Flow/Fuel(Forecast)</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Jan</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Feb</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Mar</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Apr</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>May</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Jun</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Jul</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Aug</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Sep</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Oct</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Nov</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Dec</th>
                                    <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "3vw" }}>Average</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                                {modelDeviceList.map((zone) =>
                                    // console.log(zone);
                                    zone.DATA.map((flow, indexZone) =>
                                        // console.log(flow);
                                        flow.DATA_FLOW.map((planType, indexFlow) => (
                                            <tr key={indexFlow}>
                                                {/* style={{ backgroundColor: "#FFFFFF" }} */}
                                                {indexZone == 0 && indexFlow == 0 && (
                                                    <td rowSpan={zone.DATA.length * 2} style={{ width: "1.5vw", backgroundColor: zone.COLOR, fontWeight: "bold", color: "#FFFFFF" }}>
                                                        {zone.ZONE_NAME}
                                                        {/* {indexZone} */}
                                                    </td>
                                                )}
                                                {indexFlow == 0 && (
                                                    <td rowSpan={2} style={{ width: "1.5vw", color: "#FFFFFF", fontWeight: "bold", backgroundColor: flow.TOTAL_FLOW == "Total Flow" || flow.TOTAL_FLOW == "Total Fuel" || flow.TOTAL_FLOW == "Flow/Fuel" ? zone.COLOR : "#32394e" }}>
                                                        {flow.TOTAL_FLOW}
                                                    </td>
                                                )}
                                                <td style={{
                                                    width: "1.5vw", fontWeight: "bold", backgroundColor: planType.PlanType == "Actual" ? zone.COLOR : "#293799",
                                                    color: planType.PlanType == "Actual" ? "#0615FF" : "#FFFFFF"
                                                }}>
                                                    {planType.PlanType}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.JanValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.FebValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.MarValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.AprValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.MayValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.JunValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.JulValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.AugValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.SepValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.OctValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.NovValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                    {numberFormat(planType.DecValue, 2)}
                                                </td>
                                                <td style={{ color: "#FFFFFF", fontWeight: "bold", backgroundColor: "#3454e438" }}>
                                                    {numberFormat(planType.AverageValue, 2)}
                                                </td>
                                            </tr>
                                        )
                                        )
                                    )
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>

        </React.Fragment >
    );
}

TabBillingSummary.propTypes = {
    t: PropTypes.any,
    deliveryGasYear: PropTypes.any,
};


export default TabBillingSummary;
